<template>
  <div class="page">
    <TipsHbrb ref="child"></TipsHbrb>
    <PageLoading v-if="loading"></PageLoading>
    <div class="mainbox">
      <div class="topBox">
        <div class="moreBtn" @click="showPageLink">
          <img src="@/assets/images/guess/moreBtn.png" alt="">
        </div>
    
        <div class="noteBtn" @click="showNoticePup"><img src="@/assets/images/guess/noteBtn.png" alt=""></div>
      </div>

      <div class="luckyBox" v-if="luckList.length>0">
        <div class="topBox"></div>
        <div class="centerBox">
          <!-- <div v-for="(lucky, index) in luckList" :key="index">奖品：{{lucky.prize_name}} 用户：{{formatPhoneNumber(lucky.phone)}} </div> -->
           <vue-seamless-scroll  :data="luckList" :class-option="options" class="seamless-scroll" v-if="luckList.length>0">
            <div v-for="(lucky, index) in luckList" :key="index" class="list-item">              
              <div class="phone">{{lucky.phone}} </div>  
              <div class="prize">奖品：{{lucky.prize_name}}</div>
            </div>
          </vue-seamless-scroll>
          <div class="noLucky" v-else>
            暂无
          </div>
        </div>
        <div class="bottomBox"></div>
      </div>

      <div class="luckyBoxNo" v-else>
        
      </div>




      <div class="todayImg">
        <img src="@/assets/images/guess/today.png" alt="">
      </div>
      <div class="timeBox" v-if="todayContests.length>0">
        截止时间：{{timestampToDateTime(todayContests[0].pk_endtime)}}
      </div>
      <div class="contestList">
        <div class="contestDetail" v-for="(contest, index) in todayContests" :key="index" v-if="todayContests.length>0">
          <div class="logoBox">
            <img class="team1" :src="contest.team1_logo" alt=""/>
            <img class="team2" :src="contest.team2_logo" alt=""/>
          </div>
          <div class="contestTime">{{contest.intro}}</div>
          <div class="textBox">
            <div class="team1">{{contest.team1_name}}</div>
            <div class="team2">{{contest.team2_name}}</div>
          </div>
          <div class="pkBox">
            <img class="winBtn" src="@/assets/images/guess/win1.png" alt="" @click="showConfirmPup(contest, 1, contest.team1_logo)" v-if="contest.team1_btn"/>
            <img class="winBtn" src="@/assets/images/guess/draw.png" alt="" @click="showConfirmPup(contest, 99)" v-if="contest.draw_btn"/>
            <img class="winBtn" src="@/assets/images/guess/win2.png" alt="" @click="showConfirmPup(contest, 2, contest.team2_logo)" v-if="contest.team2_btn"/>
          </div>
          <div class="proessBox">
          </div>
        </div>
        <div class="contestDetail" v-if="todayContests.length<1">
          <div class="logoBox">
           
          </div>
          <div class="contestTime"></div>
          <div class="textBox">
            <div class="team1"> </div>
            <div class="team2"> </div>
          </div>    
          <div class="proessBox">
          </div>
        </div>

        <!-- <div class="contestDetail">
          <div class="logoBox">
            <img class="team1" src="@/assets/images/guess/tuwen.png" alt=""/>
            <img class="team2" src="@/assets/images/guess/uaotx.png" alt=""/>
          </div>
          <div class="contestTime">6月14日 12:20 第四场 第一轮</div>
          <div class="textBox">
            <div class="team1">刚果民主共和国</div>
            <div class="team2">乌兹别克斯坦</div>
          </div>
          <div class="pkBox">
            <img class="winBtn" src="@/assets/images/guess/win1.png" alt=""/>
            <img class="winBtn" src="@/assets/images/guess/draw.png" alt=""/>
            <img class="winBtn" src="@/assets/images/guess/win2.png" alt=""/>
          </div>
          <div class="proessBox">            
          </div>
        </div> -->
  
      </div>
    

      <div class="navBox">
        <div class="navTxt" @click="toIndex">
          <div class="icoBox"><img src="@/assets/images/guess/index_off.png" alt=""></div>
          <div class="icoTitle">首页</div>
        </div>
        <div class="navTxt" @click="toRank">
          <div class="icoBox"><img src="@/assets/images/guess/rank_off.png" alt=""></div>
          <div class="icoTitle">排行榜</div>
        </div>
        <div class="navTxt" @click="toMyCenter">
          <div class="icoBox"><img src="@/assets/images/guess/center_off.png" alt=""></div>
          <div class="icoTitle">我的</div>
        </div>
      </div>

    </div>
    <div class="groupBox">
      <div class="history">
        <img class="beijing" src="@/assets/images/guess/history.png" alt="">
        <img class="lishiBtn" src="@/assets/images/guess/lishi.png" alt="" @click="showHistoryPup">
        <img class="weilaiBtn" src="@/assets/images/guess/weilai.png" alt="" @click="showPageFuture">
      </div>
    </div>

    <van-popup closeable close-icon="clear" class="noticePopup" v-model="showNotice">
      <div class="noticeBox">
        <div class="boxtop">
          <div class="shouhuo_txt">{{noticeTitle}}</div>
        </div>
        <div class="boxcenter">
          <div class="content" v-html="actExtend.explain"></div>
          <!-- <div class="boxBtn">
            <img src="@/assets/images/guess/shouhuo_btn.png" alt="">
          </div> -->
        </div>
        <div class="boxbottom">
          
        </div>
      </div>
    </van-popup>

    <van-popup closeable close-icon="clear" class="cListBox" v-model="showContest">
      <div class="contestHistoryBox">
        <div class="boxtop"></div>
        <div class="boxcenter">
          <div class="groupHistoryNav">
            <div class="shijian">
              <img src="@/assets/images/guess/shijian.png" alt="">
            </div>
            <div class="changci">
              <img src="@/assets/images/guess/changci.png" alt="">
            </div>
            <div class="mycontest">
              <img src="@/assets/images/guess/wode.png" alt="">
            </div>
          </div>          
          <div class="groupHistoryBox" v-for="(group, index) in historyGroup" :key="index">
              <div class="groupName">{{group.gname}}</div>
              <div class="contestHistoryList">
                <ul>
                  <li v-for="(contest, cindex) in group.contests" :key="cindex">
                    <div class="time">{{contest.note}}</div>
                    <div class="team"><font :class="contest.win_team==1?'win':''">{{contest.team1_name}}</font> vs <font :class="contest.win_team==2?'win':''">{{contest.team2_name}}</font></div>
                    <div class="status">
                      <i class="huodong icon-jian" v-if="contest.win_team<1"></i>                      
                      <i class="huodong icon-zhengque" v-else-if="contest.support>0 && contest.support==contest.win_team"></i>
                      <i class="huodong icon-cuowu" v-else-if="contest.support>0 && contest.support!=contest.win_team"></i>
                      <i class="huodong " v-else>-</i>                      
                    </div>
                  </li>                 
                </ul>
              </div>              
          </div>
        </div>
        <div class="boxbottom"></div>
      </div>
    </van-popup>

    <van-popup closeable close-icon="clear" class="noticePopup" v-model="showConfirm">
      <div class="noticeBox">
        <div class="boxtop">
          <div class="shouhuo_txt">特别提示</div>
        </div>
        <div class="boxcenter">
          <div class="popcontent">
            <img class="pingju" src="@/assets/images/guess/pingju.png" alt="" v-if="confirmData.team==99">
            <img :src="confirmData.team_logo" alt="" v-if="confirmData.team!=99 && confirmData.team_logo">
            <p>选定不可修改，请确认！</p>
          </div>
          <div class="boxBtn" @click="subPk()">
            <img src="@/assets/images/guess/shouhuo_btn.png" alt="">
          </div>
        </div>
        <div class="boxbottom">
          
        </div>
      </div>
    </van-popup>
  

  </div>
</template>

<script>

//纵览顶部提示栏及唤起app
import TipsHbrb from '@/components/TipsHbrb.vue'
import PageLoading from '@/components/PageLoading.vue'
import zonglan from '@/utils/cp-zonglan.js'
import {reqGuessInfo, reqGuessExtend, reqGroupsHistory, reqDopk, reqIsReg, reqLuckList} from '@/api/guess.js'
import { isColorDark, checkClient } from "@/utils/tool";
import Cookies from 'js-cookie'
import jump2zonglan from '@/utils/jump2app-zonglan.js'
// import bgimg from '@/assets/images/learn/pbg.jpg';
import {isWeixin} from "@/utils/wx-authorize.js" //微信授权

//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'
import { Dialog } from 'vant';

import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: 'index',
  components: {
    TipsHbrb,PageLoading,vueSeamlessScroll
  },
  data () {
    return {
       clickLock:false,
       loading: true,
       showNotice:false,
       noticeTitle:'提示',
       showContest:false,
       showConfirm:false,
       confirmData:{
          contest:'',
          team:null,
          team_name:null,
          team_logo:null
        },
       guessid:null,
       actInfo:{},
       actExtend:{},
       todayGroup:{},
       todayContests:[],
       historyGroup:[],
       isReg:false,
       luckList:[],
       listData: [
        { content: '列表项 1' },
        { content: '列表项 2' },
        { content: '列表项 3' },
        { content: '列表项 4' },
        { content: '列表项 5' },
        { content: '列表项 6' },
        { content: '列表项 7' },
        { content: '列表项 8' },
        { content: '列表项 9' },
        { content: '列表项 10' }
      ],
      options: {
        step: 0.4,          // 滚动速度
        limitMoveNum:2,    // 开始无缝滚动的最小数据量
        hoverStop: true,    // 悬停暂停
        direction: 1,       // 0向下 1向上 2向左 3向右
        autoPlay: true,     // 自动播放
        openWatch: true,    // 数据变化监控
        singleHeight: 0,    // 单步高度(0表示无缝)
        singleWidth: 0,     // 单步宽度(0表示无缝)
        waitTime: 1000      // 单步停留时间(ms)
      }
    }
  },  

  created (){
      let guessid = this.$route.query.guessid;
      if(guessid) {
        this.guessid = guessid;
        this.actInit();  //加载活动信息
        this.getLuckList();
      }
  },
  mounted () { 
    if(this.guessid) {
      let accountId = this.$store.state.accountId;
      let uniqueId = this.$store.state.uniqueId;
      if(accountId && uniqueId){
        this.accountId = accountId;
        this.uniqueId = uniqueId;
      }else{
         if (process.env.NODE_ENV === 'development') {
              // 指定用户登录测试 begin
              let accountId = '6358b3359f78a023d2b3ff8c';
              let uniqueId = '68d35c2a05e8225e32c91538';
              this.accountId = accountId;
              this.uniqueId = uniqueId;
              this.$store.commit("SET_ACCOUNTID",accountId);
              this.$store.commit("SET_UNIQUEID",uniqueId);             
              // 指定用户登录测试 end
          } else if (process.env.NODE_ENV === 'production') {
              // 生产环境
              console.log('production');
              this.cpLoad(true)  //日报客户端js-sdk加载并初始化

          }
      }
    } else {
      this.$toast({
        icon: 'warning-o',
        message: '活动不存在'
      });
    }
  },  
  computed: {},
  watch: {},
  methods: {
    formatPhoneNumber(phone) {
      if (phone && phone.length === 11) {
        phone = "" + phone;
        var ary = phone.split("");
        ary.splice(3,4,"****");
        var phone1=ary.join("");
      }
      return phone1;
    },
    timestampToDateTime(timestamp) {
      // 创建一个新的Date对象，传入Unix时间戳（毫秒）
      const date = new Date(timestamp * 1000); // 注意：如果你的时间戳已经是毫秒，则不需要乘以1000

      // 获取年、月、日、时、分、秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的，所以要加1
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      // 返回格式化的日期时间字符串
      return `${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    cpLoad(runAll) {
      let _this = this; 
      let cpMain = function() {        
          let is_login = false;
          CP.getDeviceInfo({
              completed: function(data){
                  CP.tools.writelog('get_device_info', data);                   
                  console.log('hbrb_version',data.version);
              },
              cpIncompatible: function () {
                  CP.tools.writelog('CP.getDeviceInfo', '此环境不支持此方法');
                  Dialog.confirm({
                    title: '消息提示',
                    message: '请登录客户端后参与活动',
                  }).then(() => {
                    if (/(hbxw)/i.test(navigator.userAgent)) {
                      _this.cpLoad(false);
                    } else {
                      _this.$refs.child.toLink();
                    }
                  }).catch(() => {
                    // on cancel
                  });
              }
          });
          //自身的业务代码，以下为调用样例
          CP.isLogin({  //判断是否登录的接口，
            completed: function(data){
            CP.tools.writelog('get_is_login', data);			
            if(data.is_login==1) {
              is_login=true;					
              //获取unique_id
              CP.getUniqueId({
                completed: function(data){
                  console.log('data.unique_id',data.unique_id);
                  _this.$store.commit("SET_UNIQUEID",data.unique_id);
                  _this.uniqueId = data.unique_id;
                  //获取account_id
                  CP.getAccountId({
                    completed: function(data){
                      console.log('data.account_id',data.account_id);
                      _this.$store.commit("SET_ACCOUNTID",data.account_id);
                      _this.accountId = data.account_id;
                      _this.loginInit();
                    },
                    cpIncompatible: function () {
                      CP.tools.writelog('CP.getAccountId', '此环境不支持此方法');
                    }
                  });
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.getUniqueId', '此环境不支持此方法');
                }
              });
            } else {
              //调用用户登录窗口
              CP.showLogin({
                completed: function(data){
                  if(data.is_login==1) {
                    console.log(data.account_id);
                    _this.$store.commit("SET_UNIQUEID",data.unique_id);
                    _this.$store.commit("SET_ACCOUNTID",data.account_id);
                    _this.uniqueId = data.unique_id;
                    _this.accountId = data.account_id;
                    _this.loginInit();
                  }
                  CP.tools.writelog('show_login', data);
                },
                cpIncompatible: function () {
                  CP.tools.writelog('CP.showLogin', '此环境不支持此方法');
                }
              });
            }   
          },
          cpIncompatible: function () {
            CP.tools.writelog('CP.isLogin', '此环境不支持此方法');
          }
          });
      }

      if(runAll) {
        let zjrbCp = document.createElement('script');
        zjrbCp.async = "async";
        zjrbCp.src = 'https://cdn-cp.tmuyun.com/jssdk/v1/zjrb-cp.v1.min.js';
        zjrbCp.charset = "UTF-8";
        document.body.appendChild(zjrbCp);     
        
        // localStorage.setItem('hbrb_account_id', '');
        // localStorage.setItem('hbrb_unique_id', '');

        zjrbCp.onload = function(){
          if(CP && typeof CP.ready === 'function'){
              console.log("CP准备就绪");
              CP.ready({
                debug:false,  //可选，是否是开启调试模式, 默认false
                es6Require: false, //可选，是否需要加载es6库，默认false
                ready:function(client_info){
                  //jssdk加载完成调用此方法
                  console.log('业务逻辑初始化开始');
                  cpMain();// 业务逻辑初始化的main函数
                },
                error: function (error) {
                  console.log('出现错误',error);
                }
              });
          }
        }
      } else {
        cpMain();// 业务逻辑初始化的main函数
      }       
    },
    loginInit(){

      let _this = this; 
      if(this.accountId && this.uniqueId) {
        this.getIsReg();
      } else {
        Dialog.confirm({
          title: '消息提示',
          message: '请登录客户端后参与活动',
        })
          .then(() => {
            if (/(hbxw)/i.test(navigator.userAgent)) {
              _this.cpLoad(false);
            } else {
              _this.$refs.child.toLink();
            }
          })
          .catch(() => {
            // on cancel
          });
      } 
    },
    actInit(){
      this.loading = true;
      reqGuessInfo({guessid:this.guessid}).then(res => {
        if(res.code==200) {       
          this.loading = false;   
          this.actInfo = res.data.info; 
          this.todayGroup = res.data.todayGroup;   
          this.todayContests = res.data.todayContests;
   
          this.$store.commit("SET_ACTINFO",res.data.info); 
          this.$store.commit("SET_GROUPS",res.data.topGroup);
          this.isBgDark = isColorDark(this.actInfo.bgcolor);

          //分享设置
          wxShare({
            title: this.actInfo.share_title,
            desc: this.actInfo.share_desc,
            img: this.actInfo.share_logo
          })

        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 
      
    },
    getExtend() { 
      this.loading = true;
      reqGuessExtend({guessid:this.guessid}).then(res => {
        if(res.code==200) {       
          this.loading = false;   
          this.actExtend = res.data; 
        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 
    },
    getIsReg() {
      let _this = this; 
      if(this.accountId && this.uniqueId) {
        reqIsReg({guessid:this.guessid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId}).then(res => {
          if(res.code==200) {
            this.loading = false;
            this.isReg = res.data;
          } else {
            this.loading = false;          
            this.$toast({
                icon: 'warning-o',
                message: res.msg
            });
          }
        }).catch(err => {
          this.$toast({
                icon: 'warning-o',
                message: err
            });
        }) 
      } else {
        Dialog.confirm({
          title: '消息提示',
          message: '请登录客户端后参与活动',
        })
          .then(() => {
            if (/(hbxw)/i.test(navigator.userAgent)) {
              _this.cpLoad(false);
            } else {
              _this.$refs.child.toLink();
            }
          })
          .catch(() => {
            // on cancel
          });
      } 

    },
    getLuckList(){
      reqLuckList({guessid:this.guessid}).then(res => {
        if(res.code==200) {
          this.loading = false;
          this.luckList = res.data.list;
        } else {
          this.loading = false;
          this.$toast({})
        }
      })
    },
    showConfirmPup(contest, team , team_logo){
      this.showConfirm = true;
      this.confirmData.contest = contest;
      this.confirmData.team = team;     
      this.confirmData.team_logo = team_logo;      
    },
    subPk() {       

      // 1秒内重复点击直接拦截
      if (this.clickLock) return
      this.clickLock = true
      console.log('执行点击逻辑')
      // 1秒后解锁
      setTimeout(() => {
        this.clickLock = false
      }, 1000)

      let _this = this; 
      if(this.accountId && this.uniqueId) {
        this.showConfirm = false;
        reqDopk({guessid:this.guessid, contestid:this.confirmData.contest.contestid, team:this.confirmData.team, hbrb_account_id:this.accountId, hbrb_unique_id:this.uniqueId}).then(res => {
          if(res.code==200) {       
            this.actExtend = res.data; 
            this.$toast({
                icon: 'warning-o',
                message: "感谢您的支持"
            });
          } else {
            this.$toast({
                icon: 'warning-o',
                message: res.msg
            });
          }
          this.confirmData = {};
          
        }).catch(err => {
          this.$toast({
                icon: 'warning-o',
                message: err
            });
        }) 
      } else {
        Dialog.confirm({
          title: '消息提示',
          message: '请登录客户端后参与活动',
        })
          .then(() => {
            if (/(hbxw)/i.test(navigator.userAgent)) {
              _this.cpLoad(false);
            } else {
              _this.$refs.child.toLink();
            }
          })
          .catch(() => {
            // on cancel
          });
      } 
      
    },
    showPageLink(){
      window.location.href = "https://hbxw.hebnews.cn/subject.html?id=608845&template=0";      
    },
    showPageFuture(){
      window.location.href = "https://hbxw.hebnews.cn/news.html?id=607001";      
    },
    showNoticePup(){
      this.noticeTitle = "活动说明"
      this.showNotice = true;
      this.getExtend()
    },
    showHistoryPup(){   
      this.loading = true;
      reqGroupsHistory({guessid:this.guessid, hbrb_account_id:this.accountId, hbrb_unique_id:this.uniqueId}).then(res => {
        if(res.code==200) {
          this.loading = false;
          this.showContest = true;
          this.historyGroup = res.data;   
        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 
      
    },
    toIndex(){
      this.$router.push({ path: '/index',query:this.$route.query })
    },
    toMyCenter(){
      let _this = this; 
      if(this.accountId && this.uniqueId) {
        this.$router.push({ path: '/mycenter',query:this.$route.query })
      } else {
        Dialog.confirm({
          title: '消息提示',
          message: '请登录客户端后参与活动',
        })
          .then(() => {
            if (/(hbxw)/i.test(navigator.userAgent)) {
              _this.cpLoad(false);
            } else {
              _this.$refs.child.toLink();
            }
          })
          .catch(() => {
            // on cancel
          });
      } 
      
      
    },
    toRank(){
      let _this = this; 
      if(this.accountId && this.uniqueId) {
        this.$router.push({ path: '/rank',query:this.$route.query })
      } else {
        Dialog.confirm({
          title: '消息提示',
          message: '请登录客户端后参与活动',
        })
          .then(() => {
            if (/(hbxw)/i.test(navigator.userAgent)) {
              _this.cpLoad(false);
            } else {
              _this.$refs.child.toLink();
            }
          })
          .catch(() => {
            // on cancel
          });
      } 
      
    },
  }
  
}
</script>
<style>
@media screen and (min-width: 1200px) {
  html,body { 
    display: flex; 
    justify-content: center; 
    font-size: 200px!important;
  }
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/index.scss';
</style>